import { gql } from '@apollo/client';

const CREATE_USER = gql`
  mutation registerUser($input: RegisterUserInput!) {
    registerUser(input: $input) {
      result {
        id
        netsuiteId
      }
    }
  }
`;

const CHECK_USER = gql`
  mutation registerEmail($input: RegisterEmailInput!) {
    registerEmail(input: $input) {
      result {
        id
        netsuiteId
      }
    }
  }
`;

const UPDATE_USER = gql`
  mutation updateRegisteredUser($input: UpdateRegisteredUserInput!) {
    updateRegisteredUser(input: $input) {
      result {
        id
        netsuiteId
      }
    }
  }
`;

export { CREATE_USER, UPDATE_USER, CHECK_USER };
